import { useCallback, useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { isNotEmpty, emailValidate } from '@shared/helpers/validators';
import { addCustomer, deleteCustomer, editCustomer } from 'store/slices/dashboardSlice/action';
import { dashboardActions } from 'store/slices/dashboardSlice/dashboardSlice';

import { getCustomer } from '../../helpers/getCustomer';
import { Customer } from '../../types/dashboardInformation';

export interface ErrorValidate {
    name: string | null;
    email: string | null;
}

export enum ErrorMessages {
    NAME_EMPTY = i18next.t('useModalCustomer.return.errorMessages.NAME_EMPTY'),
    EMAIL_EMPTY = i18next.t('useModalCustomer.return.errorMessages.EMAIL_EMPTY'),
    EMAIL_FORMAT = i18next.t('useModalCustomer.return.errorMessages.EMAIL_FORMAT'),
}

export const useModalCustomer = () => {
    const initialForm = useMemo(
        () => ({
            name: '',
            email: '',
            phone: '',
            description: '',
            full_name: '',
            legal_address: '',
            passport: '',
            inn: '',
            kpp: '',
            ogrn: '',
            ogrnip: '',
            okpo: '',
            bank: '',
            bik: '',
            correspondent_account_number: '',
            current_account_number: '',
            contact_name: '',
            actual_address: '',
            contact_comment: '',
        }),
        []
    );
    const dispatch = useDispatch();

    const [isShowPopup, setIsShowPopup] = useState(false);

    const onHidePopup = useCallback(() => {
        setIsShowPopup(false);
    }, []);

    const [form, setForm] = useState<Customer>(initialForm);

    const [errorValidate, setErrorValidate] = useState<ErrorValidate>({
        name: null,
        email: null,
    });

    const isError = !!errorValidate.name || !!errorValidate.email;

    const onForm = useCallback(
        (name: string, value: string) => {
            setForm((prevState) => ({ ...prevState, [name]: value }));
        },
        [form]
    );

    const { modalMode, editLoader, customerModalLoader, currentCustomerId } = useSelector(
        // @ts-ignore
        (state) => state.dashboardReducer
    );

    const onCancel = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
    }, []);

    const onClickDelete = useCallback(() => {
        setIsShowPopup(true);
    }, []);

    const onDelete = useCallback(() => {
        setForm(initialForm);
        dispatch(deleteCustomer());
    }, []);

    useEffect(() => {
        if (modalMode === 'editCustomer') {
            dispatch(dashboardActions.onCustomerModalLoader(true));
            const data = getCustomer(currentCustomerId);

            data.then((data) => {
                setForm(data);
                dispatch(dashboardActions.onCustomerModalLoader(false));
            });
        }
    }, [modalMode]);
    const onSubmit = useCallback(() => {
        const nameValidate = isNotEmpty(form.name, ErrorMessages.NAME_EMPTY);
        const emailValidates = emailValidate(form.email, {
            empty: ErrorMessages.EMAIL_EMPTY,
            format: ErrorMessages.EMAIL_FORMAT,
        });

        if (nameValidate || emailValidates) {
            setErrorValidate({
                name: nameValidate,
                email: emailValidates,
            });
            return;
        }
        setErrorValidate({
            name: null,
            email: null,
        });
        if (modalMode === 'editCustomer') {
            dispatch(editCustomer(form));
        } else {
            dispatch(addCustomer(form));
        }
    }, [form]);
    return {
        onCancel,
        modalMode,
        form,
        onForm,
        editLoader,
        customerModalLoader,
        onSubmit,
        errorValidate,
        onDelete,
        isError,
        isShowPopup,
        onHidePopup,
        onClickDelete,
    };
};
